import { TabPanel } from '@mui/lab';
import Box from '@mui/material/Box';
import { Input } from '../../../../../shared/components/Input';
import { formatCurrency } from '../../../../../shared/utils/helpers/numbers';

export const TabTotais = ({ values }: { values: any }) => {
  return (
    <TabPanel value='5'>
      <Box className='grid grid-cols-8 gap-7 pt-4'>
        <Box className={'grid grid-cols-8 col-span-4 gap-7'}>
          <Input
            disabled={true}
            label='Base de Cálculo do ICMS'
            className='col-span-2'
            name='vBC'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vBC, 2, 2)}
          />
          <Input
            disabled={true}
            label='Valor do ICMS'
            className='col-span-2'
            name='vICMS'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vICMS, 2, 2)}
          />
          <Input
            disabled={true}
            label='ICMS Desonerado'
            className='col-span-2'
            name='vICMSDeson'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vICMSDeson, 2, 2)}
          />
          <Input
            disabled={true}
            label='Fundo de Combate à Pobreza (FCP)'
            className='col-span-2'
            name='vFCP'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vFCP, 2, 2)}
          />
          <Input
            disabled={true}
            label='Base de Cálculo do ICMS ST'
            className='col-span-2'
            name='vBCST'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vBCST, 2, 2)}
          />
          <Input
            disabled={true}
            label='Valor do ICMS ST'
            className='col-span-2'
            name='vST'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vST, 2, 2)}
          />
          <Input
            disabled={true}
            label='Fundo de Combate à Pobreza Retido por Substituição Tributária (FCP ST)'
            className='col-span-2'
            name='vFCPST'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vFCPST, 2, 2)}
          />
          <Input
            disabled={true}
            label='Fundo de Combate à Pobreza Retido Anteriormente por Substituição Tributária (FCP ST Ret)'
            className='col-span-2'
            name='vFCPSTRet'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vFCPSTRet, 2, 2)}
          />
          <Input
            disabled={true}
            label='Valor Total dos Produtos'
            className='col-span-2'
            name='vProd'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vProd, 2, 2)}
          />
          <Input
            disabled={true}
            label='Valor do Frete'
            className='col-span-2'
            name='vFrete'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vFrete, 2, 2)}
          />
          <Input
            disabled={true}
            label='Valor do Seguro'
            className='col-span-2'
            name='vSeg'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vSeg, 2, 2)}
          />
          <Input
            disabled={true}
            label='Desconto'
            className='col-span-2'
            name='vDesc'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vDesc, 2, 2)}
          />
          <Input
            disabled={true}
            label='Imposto de Importação (II)'
            className='col-span-2'
            name='vII'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vII, 2, 2)}
          />
          <Input
            disabled={true}
            label='Imposto sobre Produtos Industrializados (IPI)'
            className='col-span-2'
            name='vIPI'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vIPI, 2, 2)}
          />
          <Input
            disabled={true}
            label='Valor do IPI Devolvido'
            className='col-span-2'
            name='vIPIDevol'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vIPIDevol, 2, 2)}
          />
          <Input
            disabled={true}
            label='PIS'
            className='col-span-2'
            name='vPIS'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vPIS, 2, 2)}
          />
          <Input
            disabled={true}
            label='COFINS'
            className='col-span-2'
            name='vCOFINS'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vCOFINS, 2, 2)}
          />
          <Input
            disabled={true}
            label='Outros Valores'
            className='col-span-2'
            name='vOutro'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vOutro, 2, 2)}
          />
          <Input
            disabled={true}
            label='Valor Total da Nota Fiscal'
            className='col-span-2'
            name='vNF'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vNF, 2, 2)}
          />
          <Input
            disabled={true}
            label='Total dos Tributos'
            className='col-span-2'
            name='vTotTrib'
            value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.total?.ICMSTot?.vTotTrib, 2, 2)}
          />
        </Box>
      </Box>
    </TabPanel>
  );
};
